import { render, staticRenderFns } from "./headerPageVertical.vue?vue&type=template&id=6d33545c&scoped=true&"
import script from "./headerPageVertical.vue?vue&type=script&lang=js&"
export * from "./headerPageVertical.vue?vue&type=script&lang=js&"
import style0 from "./headerPageVertical.vue?vue&type=style&index=0&id=6d33545c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d33545c",
  null
  
)

export default component.exports